import {SnackbarOrigin} from '@material-ui/core/Snackbar/Snackbar'

export const position: SnackbarOrigin = {
  vertical: 'bottom',
  horizontal: 'right',
}
